import { useCallback } from 'react'

import useApplyImageToThreeD from 'Pods/ThreeDStudio/Hooks/useApplyImageToThreeD'
import useRequireLogin from 'Pods/ThreeDStudio/Hooks/useRequireLogin'

import { NOOP } from 'Utils/stableDefaults'

// Makes a community image the 3D generator's input and takes the user to /ai, like the
// library's "Use for 3D Generation". Runs start against the asset id, so an image
// without one cannot be applied.
function useImageGenerate3d() {
  const requireLogin = useRequireLogin('login')
  const applyImageToThreeD = useApplyImageToThreeD(NOOP)

  return useCallback((image) => {
    if (!image.assetId || !requireLogin()) return

    applyImageToThreeD({ id: image.assetId, url: image.src })
  }, [applyImageToThreeD, requireLogin])
}

export default useImageGenerate3d
